export const PUSHER_CONNECT = 'PUSHER_CONNECT';
export const PUSHER_SUBSCRIBE_CHANNEL = 'PUSHER_SUBSCRIBE_CHANNEL';
export const PUSHER_CONNECTION = 'PUSHER_CONNECTION';
export const PUSHER_UNSUBSCRIBE_CHANNEL = 'PUSHER_UNSUBSCRIBE_CHANNEL';
export const PUSHER_MESSAGE_RECEIVED = 'PUSHER_MESSAGE_RECEIVED';
